import React, { useState } from "react";
import { Box, Button, HStack, Input, Text } from "@chakra-ui/react";

export function InputActionWidget({
  prompt,
  placeholder,
  type,
  default: dflt,
  onSend,
}) {
  const [value, setValue] = useState(dflt ?? "");
  const [submitted, setSubmitted] = useState(null);

  const handleSubmit = () => {
    const trimmed = value.trim();
    if (!trimmed) return;
    setSubmitted(trimmed);
    onSend(trimmed);
  };

  if (submitted) {
    return (
      <Box bg="gray.50" borderWidth="1px" borderRadius="md" p={3} my={2}>
        <Text fontSize="xs" color="gray.500" mb={1}>
          {prompt}
        </Text>
        <Text fontSize="sm">✓ {submitted}</Text>
      </Box>
    );
  }

  return (
    <Box bg="white" borderWidth="1px" borderRadius="md" p={3} my={2}>
      <Text fontSize="sm" fontWeight="medium" mb={2}>
        {prompt}
      </Text>
      <HStack>
        <Input
          size="sm"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
          placeholder={placeholder}
          type={type ?? "text"}
        />
        <Button size="sm" variant="primary" onClick={handleSubmit} isDisabled={!value.trim()}>
          Submit
        </Button>
      </HStack>
    </Box>
  );
}
